import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AnwesenheitService } from './_services/anwesenheit.service';
import { TeilnehmerService } from './_services/teilnehmer.service';
import { KursService } from './_services/kurs.service';
import { AlertService } from './_services/alert.service';
import { AuthenticationService } from './_services/authentication.service';
import { LoginComponent } from './login/login.component';
import { AlertComponent } from './_components/alert.component';
import { AuthGuard } from './_helpers/auth.guard';
import { TrainerComponent } from './trainer/trainer.component';
import { InhalteService } from './_services/inhalte.service';
import { CoachesComponent } from './coaches/coaches.component';
import { FilterPipe } from './_helpers/filter.pipe';
import { MyDatumPipe } from './_helpers/mydatum.pipe';
import { AuthInterceptor } from './_helpers/auth.interceptor';
import { ManagementComponent } from './Management/management.component';
import { StudentSearchComponent }from './_components/studentSearch.component';
import { StudentDetailsComponent } from './_components/student-details.component';
import { StudentabsencesComponent } from './_components/studentabsences.component';
import { AddAbsenceComponent } from './_components/add-absence.component';
import { ClassmgmtComponent } from './_components/classmgmt.component';
import { ChooseCoursesComponent } from './_components/choose-courses.component';
import { AddCourseentryComponent } from './_components/add-courseentry.component';
import { MergecoursemodalComponent } from './_components/mergecoursemodal.component';

//import { UserService } from './_services/user.service';
//import { VerwaltungFehlzeit } from './_components/verwaltungfehlzeiten.component';
//import { MatExpansionModule, MatSelectModule, MatDialogModule, MatListModule, MatSlideToggleModule, MatCardModule, MatButtonModule, MatToolbarModule, MatTabsModule, MatPaginatorModule, MatCheckboxModule, MatRadioModule, MatInput, MatInputModule, MatSortModule, MatButtonToggleModule, MatMenuModule } from '@angular/material';
//import { InhalteDialogComponent } from './_components/inhalte.component';
//import { VerwaltungComponent } from './verwaltung/verwaltung.component';
//import { FehlzeitenComponent } from './_components/fehltzeiten.component';
//import { InhalteNachtragDialogComponent } from './_components/inhaltenachtrag.component';
//import { TeilnehmerFehlzeit } from './_components/teilnehmerfehlzeit.component';
//import { KursFehlzeit } from './_components/kursfehlzeit.component';
//import { MessageBox } from './_components/messagebox.component';
//import { KlassenbuchVergleichDialog } from './_components/klassenbuchvergleich.component';
//import { MatTableModule } from '@angular/material/table';
//import { CdkColumnDef } from '@angular/cdk/table';


@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    TrainerComponent,
    LoginComponent,
    AlertComponent,
    CoachesComponent,
    FilterPipe,
    MyDatumPipe,
    ManagementComponent,
    StudentSearchComponent,
    StudentDetailsComponent,
    StudentabsencesComponent,
    AddAbsenceComponent,
    ClassmgmtComponent,
    ChooseCoursesComponent,
    AddCourseentryComponent,
    MergecoursemodalComponent
    //VerwaltungComponent,
    //InhalteDialogComponent,
    //FehlzeitenComponent,
    //InhalteNachtragDialogComponent,
    //TeilnehmerFehlzeit,
    //KursFehlzeit,
    //MessageBox,
    //KlassenbuchVergleichDialog,
    //VerwaltungFehlzeit,
  ],
  //entryComponents: [
  //  //InhalteDialogComponent,
  //  //FehlzeitenComponent,
  //  //InhalteNachtragDialogComponent,
  //  //MessageBox,
  //  //KlassenbuchVergleichDialog
  //],
  imports: [
    BrowserModule.withServerTransition({ appId: 'ng-cli-universal' }),
    BrowserAnimationsModule,
    ReactiveFormsModule,
    HttpClientModule,
    FormsModule,
    RouterModule.forRoot([
      { path: 'home', component: HomeComponent, pathMatch: 'full' ,canActivate:[AuthGuard]},
      { path: '', component: LoginComponent, pathMatch: 'full', canActivate: [AuthGuard]},
      { path: 'Management', component: ManagementComponent, pathMatch: 'full', canActivate: [AuthGuard]},
      { path: 'trainer', component: TrainerComponent, pathMatch: 'full', canActivate: [AuthGuard] },
      { path: 'login', component: LoginComponent, pathMatch: 'full'},
      { path: 'coaches', component: CoachesComponent, pathMatch: 'full', canActivate: [AuthGuard] }
    ])
    //MatTableModule,
    //FormsModule,
  ],
  providers: [
    AnwesenheitService,
    TeilnehmerService,
    KursService,
    AlertService,
    AuthenticationService,
    AuthGuard,
    InhalteService,
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true }
    //UserService,
    //CdkColumnDef,
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts